import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";

export function TopBanner() {
  return (
    <section className="relative bg-[#0A1E4E]" data-testid="top-flyer-banner">
      <a href="https://portal.iauoe.edu.ng/" target="_blank" rel="noopener noreferrer" className="block group">
        <motion.img
          src={IMAGES.flyerWide}
          alt="IAUE School of Basic Studies — JUPEB & IJMB admission flyer"
          className="mx-auto w-full max-w-6xl object-contain transition-transform duration-700 group-hover:scale-[1.01]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          loading="eager"
        />
      </a>
      <div className="h-1 w-full" style={{ background: "linear-gradient(90deg,#D4AF37,#F5B301,#D4AF37)" }} />
    </section>
  );
}
